export enum CheckoutPath {
  CHECKOUT_CALLBACK = 'callback',
}
